/* eslint-disable operator-linebreak */
/* eslint-disable indent */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable css-modules/no-unused-class */
import React, { ChangeEvent, useState } from 'react';
import cc from 'classnames';
import { useTheme, makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, ListSubheader, Select } from '@material-ui/core';
import { SelectProps } from 'mui-rff';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { Clear } from '@material-ui/icons';
import noop from 'utils/noop';

import styles from './TableSelect.module.scss';

interface ITableSelect {
  value?: string | number | string[];
  className?: string;
  name: string;
  onChange?: (e: ChangeEvent<{ name?: string | undefined; value: unknown }>) => void;
  onClickClear?: (name: string) => void;
  fullWidth?: boolean;
  disableClearBtn?: boolean;
}

const popoverClassesSmall = createStyles({
  paper: {
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    maxWidth: '100%',
    maxHeight: 532,
    borderRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
});

const useStyles = makeStyles((theme) => (theme.breakpoints.down('sm') ? popoverClassesSmall : {}));

const renderListSubheader = (title, onClose) => (
  <ListSubheader color="inherit" className={styles.listSubheader}>
    <h2 className={styles.listTitle}>{title}</h2>
    <Button
      color="primary"
      size="small"
      endIcon={<CloseRoundedIcon className={styles.closeIcon} />}
      className={styles.closeListBtn}
      onClick={onClose}
    >
      Close
    </Button>
  </ListSubheader>
);

const listFooter = (
  <div className={styles.listFooter}>
    <div className={styles.gradient} />
    <div className={styles.solidBlock} />
  </div>
);

const TableSelect = ({
  children,
  name,
  value,
  className,
  fullWidth,
  onChange = noop,
  onClickClear = noop,
  disableClearBtn = false,
  ...props
}: SelectProps & ITableSelect) => {
  const [open, setOpen] = useState(false);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const PopoverClasses = useStyles();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const anchorRef = React.useRef(null);

  return (
    <FormControl
      ref={anchorRef}
      variant="filled"
      fullWidth={fullWidth}
      className={cc(styles.input, className, { [styles.noLabel]: !props.label })}
    >
      {props.label && <InputLabel>{props.label}</InputLabel>}
      <Select
        {...props}
        name={name}
        onChange={(e) => onChange(e)}
        value={value}
        open={open}
        multiple={props.multiple}
        onOpen={onOpen}
        onClose={onClose}
        endAdornment={
          value &&
          String(value).length > 0 &&
          !disableClearBtn && (
            <InputAdornment position="end">
              <IconButton onClick={() => onClickClear(name)} size="small">
                <Clear style={{ fontSize: '20px' }} />
              </IconButton>
            </InputAdornment>
          )
        }
        disableUnderline
        IconComponent={(iconProps) => <ExpandMoreOutlinedIcon {...iconProps} fontSize="small" />}
        MenuProps={
          smallScreen
            ? {
                anchorReference: 'none',
                MenuListProps: {
                  subheader: renderListSubheader(props.label, onClose),
                },
                BackdropProps: { invisible: false },
                PaperProps: { elevation: 0 },
                PopoverClasses,
              }
            : { anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, getContentAnchorEl: null }
        }
      >
        {children}
        {React.Children.count(children) > 8 && listFooter}
      </Select>
    </FormControl>
  );
};

export default TableSelect;
